import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { TextFilter } from 'shared/components/filters/TextFilter';
import { debounce } from 'ts-debounce';
import { setSubmittingOrgFilter } from 'modules/settings/submodules/clients/submittingOrg/components/Filter/store/actions';

export const SubmittingOrgFilter = () => {
    const dispatch = useDispatch();
    const debounceTimeout = 50;
    const changeFilter = useMemo(() =>
        debounce(
            (newFilterValue: string) => {
                dispatch(setSubmittingOrgFilter(newFilterValue || ''));
            },
            debounceTimeout),
    [dispatch],
    );
    return (
        <TextFilter onFilterValueChanged={changeFilter} />
    );
};
